













































































































































































import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api'
import { useApi, useConfig } from '~/composables';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import Accordion from '~/components/solepro/Accordion.vue';
import AccordionGroup from '~/components/solepro/AccordionGroup.vue';
import PDPHelpBlock from '~/components/solepro/PDPHelpBlock.vue';
import { CATEGORIES_TO_REDIRECT } from '~/utils/constants/solepro/categories';
import { footerLinkTrack, trackNewsletterLink } from '~/helpers/trackings/24orepro/components';
import { GET_FOOTER_LINKS_CONFIG } from '~/modules/storeConfig/queries/getStoreCategoriesConfig.gql';
import ClientOnly from 'vue-client-only';
import { Logger } from '~/helpers/logger';


export default defineComponent({
    components: {
        Accordion,
        AccordionGroup,
        PDPHelpBlock,
        ClientOnly
    },
    setup() {
        const footerCategories = ref([]);
        const categories = useCategoryStore();
        const { config: storeConfig } = useConfig();

        const trackFooterLink = (e, title, page, callback) => {
            e.preventDefault();
            footerLinkTrack(title, page, callback)
        };

        const trackFooterNuxtLink = (title, page) => {
            footerLinkTrack(title, page, null)
        }
        const { query } = useApi();
        const FOOTER_LINKS = ref()
        useFetch(async () => {
            try {
                await categories.load()
                footerCategories.value = categories.rawCategories?.items[0]?.children.filter(el => !!el.include_in_menu) ?? [];
                footerCategories.value.forEach((c, idx) => footerCategories.value[idx].children = c.children.filter(el => !!el.include_in_menu))
                const { data } = await query(GET_FOOTER_LINKS_CONFIG)
                FOOTER_LINKS.value = JSON.parse(data['storeConfig'].sole_professionisti_footer_link)
            } catch (e) {
                Logger.warn('Footer: errore nel caricamento di categorie/link footer', e);
            }
        });
        return {
            trackNewsletterLink,
            trackFooterLink,
            trackFooterNuxtLink,
            footerCategories,
            FOOTER_LINKS,
            copyrightText: storeConfig.value.copyright,
            PI: storeConfig.value.absolute_footer,
            categoriesToRedirect: CATEGORIES_TO_REDIRECT,
            storeCode: storeConfig.value.store_code
        }

    },
    methods: {
        goToLink(link, target?:string) {
            if (target == '_blank') {
                window.open(link, target).focus();
            } else {
                window.location.href = link
            }
        }
    }
})
